module.exports = __webpack_public_path__ + "static/media/noodles.5d2e7e13.jpg";